export default __webpack_public_path__ + "static/media/favicon.e0f5182b.ico";